import React, { useEffect } from 'react';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import BlockBuilder from '../../BlockBuilder';

import SectionContainer from '../SectionContainer';
import css from './SectionCarousel.module.css';
import { ensureListing } from '../../../../util/data';

const KEY_CODE_ARROW_LEFT = 37;
const KEY_CODE_ARROW_RIGHT = 39;

// const blockTemplate = {
//   media: {
//     fieldType: 'image',
//     image: {
//       id: '6d09bfd2-94e2-5ab0-8f37-91aca829ee91',
//       type: 'imageAsset',
//       attributes: {
//         variants: {
//           landscape400: {
//             height: 225,
//             width: 400,
//             url:
//               'https://sharetribe-assets.imgix.net/679ec756-8e1a-4eb9-aa53-822489116ee3/raw/d6/1d1a88eaf8747ebd445150695fd42d13687d3b?auto=format&crop=edges&fit=crop&h=225&w=400&s=4f3f78d762b36f879c95ba0908b850de',
//             name: 'landscape400',
//           },
//           landscape800: {
//             height: 450,
//             width: 800,
//             url:
//               'https://sharetribe-assets.imgix.net/679ec756-8e1a-4eb9-aa53-822489116ee3/raw/d6/1d1a88eaf8747ebd445150695fd42d13687d3b?auto=format&crop=edges&fit=crop&h=450&w=800&s=76664cc8bb75e56bf520427661413f3c',
//             name: 'landscape800',
//           },
//           landscape1200: {
//             height: 675,
//             width: 1200,
//             url:
//               'https://sharetribe-assets.imgix.net/679ec756-8e1a-4eb9-aa53-822489116ee3/raw/d6/1d1a88eaf8747ebd445150695fd42d13687d3b?auto=format&crop=edges&fit=crop&h=675&w=1200&s=346bf6badb6e413df60aeaf8c411b3ca',
//             name: 'landscape1200',
//           },
//           landscape2400: {
//             height: 1350,
//             width: 2400,
//             url:
//               'https://sharetribe-assets.imgix.net/679ec756-8e1a-4eb9-aa53-822489116ee3/raw/d6/1d1a88eaf8747ebd445150695fd42d13687d3b?auto=format&crop=edges&fit=crop&h=1350&w=2400&s=1f14a3588b1f305f580b6ab139d967c2',
//             name: 'landscape2400',
//           },
//         },
//         assetPath:
//           '/content/pages/landing-page/block-media-0194c3ce-848a-8edd-ac5d-bc9676702920.jpg',
//       },
//     },
//     aspectRatio: '16/9',
//     link: {
//       fieldType: 'internalImageLink',
//       href: 'l/audi-a4-2024/679e8a9f-348e-4dc9-816b-bc2285731439',
//     },
//     alt: 'Audi A4 2024 thumbnail',
//   },
//   title: {
//     fieldType: 'heading3',
//     content: 'Audi A4 2024 • €39,900',
//   },
//   text: {
//     fieldType: 'markdown',
//     content:
//       'New, 2023, Hybrid (Petrol + Electric), Sedan, Rear-Wheel Drive (RWD), 2.6L – 3.5L\n***\n**Mileage**: 35700km ',
//   },
//   callToAction: {
//     fieldType: 'internalButtonLink',
//     content: 'Ver anuncio',
//     href: '/l/audi-a4-2024/679e8a9f-348e-4dc9-816b-bc2285731439',
//   },
//   alignment: 'left',
//   blockType: 'defaultBlock',
//   blockName: 'Car 1',
// };

// function transformListings(listings) {
//   return listings.map(listing => {
//     const { id, attributes, relationships } = listing;
//     const { title, price, publicData, mileage, year, description } = attributes;
//     console.log(listing);
//     const firstImageId = relationships.images?.data[0]?.id.uuid || '';
//     const imageUrlBase = `https://sharetribe-assets.imgix.net/679ec756-8e1a-4eb9-aa53-822489116ee3/${firstImageId}`;

//     return {
//       media: {
//         fieldType: 'image',
//         image: {
//           id: firstImageId,
//           type: 'imageAsset',
//           attributes: {
//             variants: {
//               landscape400: {
//                 height: 225,
//                 width: 400,
//                 url: `${imageUrlBase}?auto=format&crop=edges&fit=crop&h=225&w=400`,
//                 name: 'landscape400',
//               },
//               landscape800: {
//                 height: 450,
//                 width: 800,
//                 url: `https://sharetribe.imgix.net/679ec756-8e1a-4eb9-aa53-822489116ee3/${firstImageId}?auto=format&crop=edges&fit=crop&h=300&w=400&s=81cfc15702e1a8ae2d8efb2ea294bccb`,
//                 name: 'landscape800',
//               },
//               landscape1200: {
//                 height: 675,
//                 width: 1200,
//                 url: `${imageUrlBase}?auto=format&crop=edges&fit=crop&h=675&w=1200`,
//                 name: 'landscape1200',
//               },
//               landscape2400: {
//                 height: 1350,
//                 width: 2400,
//                 url: `${imageUrlBase}?auto=format&crop=edges&fit=crop&h=1350&w=2400`,
//                 name: 'landscape2400',
//               },
//             },
//             assetPath: `/content/pages/landing-page/${firstImageId}.jpg`,
//           },
//         },
//         aspectRatio: '16/9',
//         link: {
//           fieldType: 'internalImageLink',
//           href: `/l/${title.replace(/\s+/g, '-').toLowerCase()}/${id.uuid}`,
//         },
//         alt: title,
//       },
//       title: {
//         fieldType: 'heading3',
//         content: `${title} • €${(price.amount / 100).toLocaleString()}`,
//       },
//       text: {
//         fieldType: 'markdown',
//         content: `Mileage: ${mileage} km`,
//       },
//       callToAction: {
//         fieldType: 'internalButtonLink',
//         content: 'Ver anuncio',
//         href: `/l/${title.replace(/\s+/g, '-').toLowerCase()}/${id.uuid}`,
//       },
//       alignment: 'left',
//       blockType: 'defaultBlock',
//       blockName: title,
//     };
//   });
// }

// The number of columns (numColumns) affects styling and responsive images
const COLUMN_CONFIG = [
  { css: css.oneColumn, responsiveImageSizes: '(max-width: 767px) 100vw, 1200px' },
  { css: css.twoColumns, responsiveImageSizes: '(max-width: 767px) 100vw, 600px' },
  { css: css.threeColumns, responsiveImageSizes: '(max-width: 767px) 100vw, 400px' },
  { css: css.fourColumns, responsiveImageSizes: '(max-width: 767px) 100vw, 290px' },
];
const getIndex = numColumns => numColumns - 1;
const getColumnCSS = numColumns => {
  const config = COLUMN_CONFIG[getIndex(numColumns)];
  return config ? config.css : COLUMN_CONFIG[0].css;
};
const getResponsiveImageSizes = numColumns => {
  const config = COLUMN_CONFIG[getIndex(numColumns)];
  return config ? config.responsiveImageSizes : COLUMN_CONFIG[0].responsiveImageSizes;
};

/**
 * @typedef {Object} BlockConfig
 * @property {string} blockId
 * @property {string} blockName
 * @property {'defaultBlock' | 'footerBlock' | 'socialMediaLink'} blockType
 */

/**
 * @typedef {Object} FieldComponentConfig
 * @property {ReactNode} component
 * @property {Function} pickValidProps
 */

/**
 * Section component that's able to show blocks in a carousel.
 * The number blocks visible is defined by "numColumns" prop.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {Object} props.defaultClasses
 * @param {string} props.defaultClasses.sectionDetails
 * @param {string} props.defaultClasses.title
 * @param {string} props.defaultClasses.description
 * @param {string} props.defaultClasses.ctaButton
 * @param {string} props.sectionId id of the section
 * @param {'carousel'} props.sectionType
 * @param {number?} props.numColumns
 * @param {Object?} props.title
 * @param {Object?} props.description
 * @param {Object?} props.appearance
 * @param {Object?} props.callToAction
 * @param {Array<BlockConfig>?} props.blocks array of block configs
 * @param {boolean?} props.isInsideContainer
 * @param {Object} props.options extra options for the section component (e.g. custom fieldComponents)
 * @param {Object<string,FieldComponentConfig>?} props.options.fieldComponents custom fields
 * @returns {JSX.Element} Section for article content
 */
const SectionCarousel = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    numColumns = 1,
    title,
    description,
    appearance,
    callToAction,
    blocks = [],
    options,
  } = props;
  const sliderContainerId = `${props.sectionId}-container`;
  const sliderId = `${props.sectionId}-slider`;
  const numberOfBlocks = blocks?.length;
  const hasBlocks = numberOfBlocks > 0;

  useEffect(() => {
    const setCarouselWidth = () => {
      if (hasBlocks) {
        const windowWidth = window.innerWidth;
        const elem = window.document.getElementById(sliderContainerId);
        const scrollbarWidth = window.innerWidth - document.body.clientWidth;
        const elementWidth =
          elem.clientWidth >= windowWidth - scrollbarWidth ? windowWidth : elem.clientWidth;
        const carouselWidth = elementWidth - scrollbarWidth;

        elem.style.setProperty('--carouselWidth', `${carouselWidth}px`);
      }
    };
    setCarouselWidth();

    window.addEventListener('resize', setCarouselWidth);
    return () => window.removeEventListener('resize', setCarouselWidth);
  }, []);

  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);

  const onSlideLeft = e => {
    var slider = window.document.getElementById(sliderId);
    const slideWidth = numColumns * slider?.firstChild?.clientWidth;
    slider.scrollLeft = slider.scrollLeft - slideWidth;
    // Fix for Safari
    e.target.focus();
  };

  const onSlideRight = e => {
    var slider = window.document.getElementById(sliderId);
    const slideWidth = numColumns * slider?.firstChild?.clientWidth;
    slider.scrollLeft = slider.scrollLeft + slideWidth;
    // Fix for Safari
    e.target.focus();
  };

  const onKeyDown = e => {
    if (e.keyCode === KEY_CODE_ARROW_LEFT) {
      // Prevent changing cursor position in input
      e.preventDefault();
      onSlideLeft(e);
    } else if (e.keyCode === KEY_CODE_ARROW_RIGHT) {
      // Prevent changing cursor position in input
      e.preventDefault();
      onSlideRight(e);
    }
  };

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <header className={defaultClasses.sectionDetails}>
          <Field data={title} className={defaultClasses.title} options={fieldOptions} />
          <Field data={description} className={defaultClasses.description} options={fieldOptions} />
          <Field data={callToAction} className={defaultClasses.ctaButton} options={fieldOptions} />
        </header>
      ) : null}
      {hasBlocks ? (
        <div className={css.carouselContainer} id={sliderContainerId}>
          <div
            className={classNames(css.carouselArrows, {
              [css.notEnoughBlocks]: blocks.length <= numColumns,
            })}
          >
            <button className={css.carouselArrowPrev} onClick={onSlideLeft} onKeyDown={onKeyDown}>
              ‹
            </button>
            <button className={css.carouselArrowNext} onClick={onSlideRight} onKeyDown={onKeyDown}>
              ›
            </button>
          </div>
          <div className={getColumnCSS(numColumns)} id={sliderId}>
            <BlockBuilder
              rootClassName={css.block}
              ctaButtonClass={defaultClasses.ctaButton}
              blocks={blocks}
              sectionId={sectionId}
              responsiveImageSizes={getResponsiveImageSizes(numColumns)}
              options={options}
            />
          </div>
        </div>
      ) : null}
    </SectionContainer>
  );
};

export default SectionCarousel;
